<template>
  <div class="drag-sort-container">
    <div
      v-for="(item, index) in list"
      v-show="((type == 1 && !item.hiddenByDefault) || (type == 2 && item.hiddenByDefault)) && !item.searchShow"
      :key="item.id"
      class="drag-item"
      :class="[
        {
          'dragging': draggingIndex === index,
          'drag-ghost': isDragging && draggingIndex === index,
        },
        'item',
        type == 1 ? '' : 'pre',
      ]"
      draggable="true"
      @dragstart="handleDragStart(index, $event)"
      @dragover.prevent
      @dragenter="handleDragEnter(index)"
      @dragend="handleDragEnd"
    >
      <svg
        v-if="type == 1 && search == '' && !item.fixed"
        class="iconfont souding"
        t="1764054262899"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="6644"
        width="16"
        height="16"
      >
        <path
          d="M344 132c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m70 380c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m336 0c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70zM344 752c38.66 0 70 31.34 70 70s-31.34 70-70 70-70-31.34-70-70 31.34-70 70-70z m406 70c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z m0-620c0-38.66-31.34-70-70-70s-70 31.34-70 70 31.34 70 70 70 70-31.34 70-70z"
          fill="#323338"
          p-id="6645"
        />
      </svg>
      <div
        class="label"
        draggable="false"
        @mousedown.prevent
      >
        {{ item.label }}
      </div>
      <div
        v-show="!item.fixed"
        class="icon"
        draggable="false"
        @mousedown.prevent
        @click="statusShowFn(index)"
      >
        <svg
          v-if="type == 1"
          t="1764054636635"
          class="zjanshi"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="8662"
          width="18"
          height="18"
        >
          <path
            d="M953.9 493.2A852.1 852.1 0 0 0 826.9 360C722.5 270.9 613.6 224 512 224 268.8 224 78.1 482.2 70 493.2a32.1 32.1 0 0 0 0 37.6 852.1 852.1 0 0 0 127 133.6C301.5 753.1 410 800 512 800c243.2 0 433.9-258.2 441.9-269.2a32.1 32.1 0 0 0 0-37.6zM512 736c-175.4 0-328.2-167-375.3-224 47-57.1 199.5-224 375.3-224S840 454.9 887.2 512C840 569.1 687.4 736 512 736z"
            p-id="8663"
          />
          <path
            d="M512 352a160 160 0 1 0 160 160 160 160 0 0 0-160-160z m0 256a96 96 0 1 1 96-96 96.2 96.2 0 0 1-96 96z"
            p-id="8664"
          />
        </svg>
        <svg
          v-if="type == 2"
          t="1764054771640"
          class="yincang"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="10557"
          width="16"
          height="16"
        >
          <path
            d="M562.393 293.696a32 32 0 0 1-14.336 62.4 160 160 0 0 0-185.056 214.336 32 32 0 1 1-59.584 23.328 224 224 0 0 1 258.976-300.064zM462.137 730.4a32 32 0 0 1 14.208-62.4A160 160 0 0 0 664.57 463.52a32 32 0 1 1 60.992-19.328A224 224 0 0 1 462.105 730.4z"
            p-id="10558"
          />
          <path
            d="M213.465 676.096a32 32 0 1 1-42.336 48C132.057 689.6 77.497 625.568 6.457 531.264a32 32 0 0 1-0.992-37.12C154.17 272.704 323.225 160 512.025 160c52.704 0 104.096 8.832 154.016 26.496a32 32 0 0 1-21.344 60.352A394.752 394.752 0 0 0 512.025 224c-159.584 0-306.24 94.464-440.576 287.04 61.824 81.056 109.44 136.288 142.048 165.056z m599.808-325.76a32 32 0 0 1 42.592-47.808c38.368 34.24 91.968 97.376 161.728 190.24a32 32 0 0 1 0.992 37.088C869.881 751.296 700.825 864 512.025 864c-37.824 0-74.944-4.544-111.36-13.664a32 32 0 0 1 15.488-62.08c31.36 7.84 63.264 11.744 95.872 11.744 159.584 0 306.24-94.464 440.576-287.04-60.64-79.712-107.328-134.112-139.328-162.656z m10.656-227.424a32 32 0 0 1 48.192 42.176l-672 768a32 32 0 0 1-48.192-42.176l672-768z"
            p-id="10559"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
// 定义Props
const props = defineProps({
  list: {
    type: Array,
    required: true,
  },
  sort: {
    type: Boolean,
    default: false,
  },
  type: {
    type: Number,
    default: 1, // 1:展示 2:不展示
    validator: (val) => [1, 2].includes(val),
  },
  search: {
    type: String,
    default: '',
  },
});

// 定义响应式数据（替代Vue2的data）
const localList = ref(JSON.parse(JSON.stringify(props.list)));
watch(
  () => props.list,
  (list) => {
    localList.value = JSON.parse(JSON.stringify(list));
  },
  { deep: true },
);
const draggingIndex = ref(-1);
const dragOverIndex = ref(-1);
const isDragging = ref(false);
const dragStartY = ref(0);
const itemHeight = ref(0);
const emit = defineEmits(['update', 'update:list']);
// 监听搜索文本变化（Vue3 版本）
watch(
  () => props.search, // 监听的源：props 中的 search
  (value) => {
    // 遍历列表项，根据搜索值设置显示状态
    localList.value.forEach((item) => {
      // 检查标签是否包含搜索值（不区分大小写可添加 .toLowerCase()）
      item.searchShow = item.label.indexOf(value) === -1;
    });

    // Vue3 响应式系统会自动更新，无需 forceUpdate
  },
  { immediate: true }, // 初始化时立即执行一次
); // 监听搜索文本变化（Vue3 版本）

function statusShowFn(index) {
  localList.value[index].hiddenByDefault = !localList.value[index].hiddenByDefault;
  updateFn();
}

const handleDragStart = (index, event) => {
  // 阻止特定元素触发拖拽（标签或图标元素）
  if (event.target.classList.contains('label') || event.target.classList.contains('icon')) {
    // 若是指定元素，直接阻止拖拽逻辑
    event.preventDefault();
    return;
  }

  // 更新拖拽状态
  draggingIndex.value = index;
  isDragging.value = true;
  dragStartY.value = event.clientY;

  // 获取元素高度用于计算动画
  const item = event.target.closest('.drag-item');
  itemHeight.value = item.offsetHeight;

  // 禁用拖拽元素的过渡效果
  item.classList.add('no-transition');

  // 添加拖拽样式（使用setTimeout确保样式生效）
  setTimeout(() => {
    item.classList.add('drag-ghost');
  }, 0);
};

function handleDragEnter(index) {
  if (draggingIndex.value === -1 || index === draggingIndex.value || localList.value[index].fixed) return; // false:下移
  // 记录当前拖拽位置
  const fromIndex = draggingIndex.value;
  moveItem(fromIndex, index);
  // 执行列表重排
  dragOverIndex.value = index;

  draggingIndex.value = index;
}

function handleDragEnd() {
  isDragging.value = false;
  draggingIndex.value = -1;
  dragOverIndex.value = -1;

  // 移除所有临时样式
  document.querySelectorAll('.drag-item').forEach((item) => {
    item.classList.remove('drag-ghost', 'no-transition', 'transition-transform');
  });
  // 通知父组件更新数据
  updateFn();
}

function moveItem(fromIndex, toIndex) {
  const item = localList.value.splice(fromIndex, 1)[0];
  localList.value.splice(toIndex, 0, item);
}
const updateFn = () => {
  emit('update:list', JSON.parse(JSON.stringify(localList.value)));
  emit('update');
};
//    function updateFn() {
//         this.$emit('update')
//         this.$emit('update:list', [...this.list]);
//     }
//     }
// }
</script>

<style scoped lang="scss">
.pre {
  color: #999 !important;
}
.zjanshi {
  fill: #333;
  &:hover {
    fill: #1fc069 !important;
  }
}
.yincang {
  fill: #999;
  &:hover {
    fill: #1fc069 !important;
  }
}

.souding {
  line-height: 60px;
  cursor: move;
  position: relative;
  top: 10px;
  margin-inline-end: 5px;
}

.drag-sort-container {
  display: flex;
  flex-direction: column;
}

.item {
  display: flex;
  line-height: 40px;
  box-sizing: border-box;
  color: #333333;

  .sort {
    padding-inline-end: 5px;
    box-sizing: border-box;
    cursor: move;
  }

  .zty-suoding {
    cursor: default;
    width: 0;
  }

  .label {
    flex: 1;
  }
}

.dragging {
  z-index: 10;
}

.drag-ghost {
  opacity: 0.7;
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* 过渡动画 */
.transition-transform {
  // transition: transform 0.3s;
  // transform: translateY(40px);
}

.no-transition {
  transition: none !important;
}

/* 元素交换位置时的动画效果 */
.drag-item:not(.drag-ghost):hover {
  // transform: translateX(5px);
}
</style>
